module.exports = __webpack_public_path__ + "static/daily_activity@2x-825d6c190e3089e1f1fa0093f4fa0d96.png";